import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @mui/material components
import Box from "@mui/material/Box";

// shared color header styles (kept in material-kit-react.js — do not duplicate)
import {
  warningCardHeader,
  successCardHeader,
  dangerCardHeader,
  infoCardHeader,
  primaryCardHeader
} from "../../styles/material-kit-react.js";

// sx styles (migrated from JSS cardHeaderStyle.js — Faz 7)
const cardHeaderSx = {
  borderRadius: "3px",
  padding: "1rem 15px",
  marginLeft: "15px",
  marginRight: "15px",
  marginTop: "-30px",
  border: "0",
  marginBottom: "0"
};
const cardHeaderPlainSx = {
  marginLeft: "0px",
  marginRight: "0px"
};
const colorCardHeaderSx = {
  warning: warningCardHeader,
  success: successCardHeader,
  danger: dangerCardHeader,
  info: infoCardHeader,
  primary: primaryCardHeader
};

export default function CardHeader(props) {
  const { className, children, color, plain, ...rest } = props;
  const sx = {
    ...cardHeaderSx,
    ...(color && colorCardHeaderSx[color] ? colorCardHeaderSx[color] : {}),
    ...(plain ? cardHeaderPlainSx : {})
  };
  return (
    <Box className={className} sx={sx} {...rest}>
      {children}
    </Box>
  );
}

CardHeader.propTypes = {
  className: PropTypes.string,
  color: PropTypes.oneOf(["warning", "success", "danger", "info", "primary"]),
  plain: PropTypes.bool,
  children: PropTypes.node
};
